import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import { SET_FORCE_ACTIVATION_RESULT } from 'state/actionTypes';

const forceActivationInitialState = {
  data: [],
};

const forceActivationResult = createReducer(forceActivationInitialState, {
  [SET_FORCE_ACTIVATION_RESULT]: (state, { result }) => ({
    ...state,
    ...result,
  }),
});

export default combineReducers({
  forceActivationResult,
});
